var components = {'uPopup': require('uview-ui/components/u-popup/u-popup.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-popup',{staticClass:"dialog",attrs:{"mode":_vm.mode,"bgColor":"transparent"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }